if (process.browser) {
  require('~/lib/jquery.plugin.js')
  require('~/lib/jquery.datepick.js')
  require('~/lib/select2.full.min')
}